module.exports = __webpack_public_path__ + "img/img_62.4cf3aa93.png";